import { customerService } from "../../services/customer";
import { alertActions } from "./alert-actions";
import { adminConstants } from "../constant/admin-constant";
import { history } from "helper/history";

export const customerActions = {
    storeCustomer,
    updateCustomer,
    getCustomerPagination,
    deleteCustomer,
    storeCustomerAddress,
    getCustomerAddressesPagination,
    getAddressItem,
    deleteAddress,
    editCustomerAddress,
    getCustomer,
    getCustomersDropdown,
    approveCustomer
};

function getCustomer(id) {
    return dispatch => {
        return customerService.getCustomer(id).then(response => {
            dispatch({
                type: adminConstants.GET_CUSTOMER_SUCCESS,
                payload: response
            });
            return response;
        });
    };
}

function deleteAddress(list_id) {
    return dispatch => {
        return customerService.deleteAddress(list_id).then(
            response => {
                dispatch({
                    type: adminConstants.DELETE_ADDRESS_ITEM_SUCCESS,
                    payload: response
                });
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch({
                    type: adminConstants.DELETE_ADDRESS_ITEM_FAILURE,
                    payload: error
                });
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getAddressItem(id) {
    return dispatch => {
        return customerService.getAddressItem(id).then(
            list => {
                dispatch({
                    type: adminConstants.GET_ADDRESS_ITEM_SUCCESS,
                    payload: list
                });
            },
            error => {
                dispatch({
                    type: adminConstants.GET_ADDRESS_ITEM_FAILURE,
                    payload: error
                });
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getCustomerAddressesPagination(
    id,
    page,
    sort,
    pageSize,
    component_name,
    pagination
) {
    return dispatch => {
        customerService
            .getCustomerAddressesPagination(
                id,
                page,
                sort,
                pageSize,
                component_name,
                pagination
            )
            .then(
                response => {
                    dispatch({
                        type: adminConstants.PAGINATION_CUST_ADDRESSES_SUCCESS,
                        payload: response.result.address
                    });
                },
                error => {
                    dispatch({
                        type: adminConstants.PAGINATION_CUST_ADDRESSES_FAILURE,
                        payload: error
                    });
                }
            );
    };
}

function storeCustomerAddress(data) {
    return dispatch => {
        return customerService.storeCustomerAddress(data).then(response => {
            dispatch({
                type: adminConstants.STORE_CUSTMER_ADDRESS,
                payload: response
            });
            dispatch(alertActions.success(response.message));
            return data;
        });
    };
}

function editCustomerAddress(data, id) {
    return dispatch => {
        return customerService.editCustomerAddress(data, id).then(
            response => {
                dispatch({
                    type: adminConstants.STORE_CUSTMER_ADDRESS,
                    payload: response
                });
                dispatch(alertActions.success(response.message));
                return data;
            },
            error => {
                //dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function deleteCustomer(data) {
    return dispatch => {
        return customerService.deleteCustomer(data).then(
            response => {
                dispatch({
                    type: adminConstants.DELETE_CUSTOMER_SUCCESS,
                    payload: response
                });
                dispatch(alertActions.success(response.message));
            },
            error => { }
        );
    };
}

function updateCustomer(data, id) {
    return dispatch => {
        customerService.updateCustomer(data, id).then(
            response => {
                //dispatch(success(response));
                dispatch(alertActions.success(response.message));
                history.push("/Admin/customers");
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    // function request() {
    //     return { type: adminConstants.STORE_CUSTOMER_REQUEST };
    // }
    // function success(response) {
    //     return {
    //         type: adminConstants.STORE_CUSTOMER_SUCCESS,
    //         payload: response
    //     };
    // }
    function failure(error) {
        return { type: adminConstants.STORE_CUSTOMER_FAILURE, payload: error };
    }
}

function storeCustomer(data) {
    return dispatch => {
        customerService.storeCustomer(data).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                history.push("/Admin/customers");
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    // function request() {
    //     return { type: adminConstants.STORE_CUSTOMER_REQUEST };
    // }
    function success(response) {
        return {
            type: adminConstants.STORE_CUSTOMER_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return { type: adminConstants.STORE_CUSTOMER_FAILURE, payload: error };
    }
}
function getCustomersDropdown(page, filter, sort, pageSize) {
    return dispatch => {
        customerService
            .getCustomersDropdown(page, filter, sort, pageSize)
            .then(response => {
                dispatch({
                    type: adminConstants.CUSTOMERS_DROPDOWN_LIST_SUCCESS,
                    payload: response.result
                });
            });
    };
}
function getCustomerPagination(page, filter, sort, pageSize, status) {
    return dispatch => {
        customerService
            .getCustomerPagination(page, filter, sort, pageSize, status)
            .then(
                response => {
                    dispatch(success(response.result));
                    // dispatch(alertActions.success(response.message));
                },
                error => {
                    dispatch(failure(error));
                    // dispatch(alertActions.error(error));
                }
            );
    };
    // function request() {
    //     return { type: adminConstants.PAGINATION_CUSTOMERS_REQUEST };
    // }
    function success(response) {
        return {
            type: adminConstants.PAGINATION_CUSTOMERS_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.PAGINATION_CUSTOMERS_FAILURE,
            payload: error
        };
    }
}

function approveCustomer(id) {
    return dispatch => {
        return customerService
            .approveCustomer(id)
            .then(response => {
                dispatch(alertActions.success(response.message));
            })
            .catch(err => {
                dispatch(alertActions.error(err));
                return Promise.reject(err);
            })
            ;
    };
}


// WEBPACK FOOTER //
// ./src/redux/actions/customer-action.jsx